import React from "react";
import MasterDataListPage from "../MasterDataListPage";
import { createHttpClient } from "../../../api/client";


// const DEFAULT_TEMPLATE = `✨ {name} {storage} – สี{color} ✨
// ราคาเพียง {price} บาท | {is_used}
// สภาพเครื่อง: {quality}
// {insurance_expired_date}
// 🔋 แบตเตอรี่ {battery_health} {charge_cycles}
// 📦 อุปกรณ์ {inventory}
// {admin_description}
// • รับประกันหลังการขายทุกเครื่อง
// • ผ่านการตรวจเช็คทุกการใช้งาน
// • รับซื้อ เทิร์น ฝาก ผ่อนได้ใช้ใบขับขี่หรือบัตรประชาชน
// • บริการรับรูดบัตรเครดิต +3%
// • ไม่ติด iCloud สามารถอัปเดทหรือรีเซ็ตได้
// • สินค้าทางร้านรับซื้อคืนทุกเครื่อง
// • จัดส่งด่วน Grab | Flash | Kerry
// • Video Call ตรวจสอบสินค้าก่อนได้
// ———————————————
// รับซื้อ - ขาย - ฝาก - เทิร์น - ผ่อน iPhone iPad สันติธรรมเชียงใหม่`;

export default function MainCategoriesPage() {
  const http = React.useMemo(() => createHttpClient(), []);
  const [template, setTemplate] = React.useState("");
  const [templateModelId, setTemplateModelId] = React.useState(null);

  React.useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const res = await http.get("/models", {
          params: {
            sort: ["sequence:asc", "id:asc"],
            pagination: { pageSize: 300 },
          },
        });

        const list = Array.isArray(res?.data?.data) ? res.data.data : [];
        const picked =
          list.find((x) => String(x?.template || "").trim() !== "") || list[0] || null;

        if (!alive) return;
        setTemplateModelId(picked?.id ? String(picked.id) : null);
        setTemplate(String(picked?.template ?? ""));
      } catch (err) {
        console.error("GET /models template error:", err);
        if (!alive) return;
        setTemplateModelId(null);
        setTemplate("");
      }
    })();

    return () => {
      alive = false;
    };
  }, [http]);

  return (
    <MasterDataListPage
      title="Master Data"
      subtitle="ประเภทสินค้าหลัก"
      apiPath="/categories"
      fieldKey="name"
      createDefaultName="รายการใหม่"
      initialItems={[]}
      showSubButton
      subLabel="เพิ่มรุ่น"
      subRouteBuilder={(cat) =>
        `/app/settings/master/categories/${cat.id}/models`
      }
      showSubDropdown
      subTitle="รุ่นทั้งหมด"
      subFieldKey="name"
      subListFetcher={async (cat) => {
        const res = await http.get("/category-models", {
          params: {
            filters: { category: { id: { $eq: cat.id } } },
            sort: ["id:desc"],
            pagination: { pageSize: 200 },
          },
        });
        return res?.data?.data || [];
      }}
      showTemplateButton
      templateButtonTitle="เทมเพลตคำอธิบายสินค้า"
      templateValue={template}
      onSaveTemplate={async (value) => {
        const nextTemplate = String(value ?? "");

        if (templateModelId) {
          await http.put(`/models/${templateModelId}`, {
            data: { template: nextTemplate },
          });
        } else {
          const created = await http.post("/models", {
            data: { name: "Template", template: nextTemplate },
          });
          const createdId = created?.data?.data?.id;
          setTemplateModelId(createdId ? String(createdId) : null);
        }

        setTemplate(nextTemplate);
      }}
    />
  );
}